import React from 'react';
import ReactDOM from 'react-dom';
import {HashRouter, Route, Switch} from 'react-router-dom';
import indexRoutes from 'routes/index.jsx';
// import registerServiceWorker from './registerServiceWorker';
import ReactGA from 'react-ga';

import 'asset/css/index.css';
import 'asset/css/bootstrap.min.css';
import 'asset/css/AppStyle.css';
import 'asset/css/light-bootstrap-dashboard.css';
import '../node_modules/react-table/react-table.css';

ReactDOM.render((
    <div>
        {ReactGA.initialize('UA-122954972-1')}
    <HashRouter>
            
        <Switch>
            {indexRoutes.map((prop, key) => {
                return (<Route path={prop.path} component={prop.component} key={key}/>);
            })
}
        </Switch>
    </HashRouter>
    </div>
), document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js